import { Base } from '@app/shared/models/base.model'
import { User } from '@app/modules/user/user.model'
import { UriName } from '@app/modules/uri-name/uri-name.model'

export class Uri extends Base {
  uuid: string = null
  uriNameUuid: string = null
  uriName: UriName = null
  url: string = null
  // ---------------------------------------------------------------------------
  createdAt: Date = null
  updatedAt: Date = null
  deletedAt: Date = null
  createdByUuid: string = null
  createdByUser: User = null
  updatedByUuid: string = null
  updatedByUser: User = null

  /**
   * Properties with type Date
   *
   * @type {Array<string>}
   */
  protected _dates: Array<string> = [
    'createdAt',
    'updatedAt',
    'deletedAt'
  ]

  /**
   * Constructor
   *
   * @param {Partial<Uri>} data Initial values
   */
  public constructor (data?: Partial<Uri>) {
    super(data)
    this.init(data)
  }
}
